module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/campaign_banner_202505_sp_e394ece3a1e4c17abe3abee01a37bd54.webp";